import { Col, Row } from "antd";
import React from "react";
import styled from "styled-components";
import { theme } from "../../../theme";
import PageFilterInputs from "../../atoms/PageFilterInputs";
import PageTitle from "../../atoms/PageTitle";

interface Props {
  title: string;
  inputs: React.ReactNode[];
  smallPageTitle?: string;
  margin?: string;
}
const PageFilter: React.FC<Props> = ({
  title,
  inputs,
  smallPageTitle,
  margin,
}) => {
  return (
    <PageFilterWrapper margin={margin}>
      <Row>
        <Col span={24}>
          <SmallPageTitle>{smallPageTitle}</SmallPageTitle>
        </Col>
        <Col span={24}>
          <PageTitle>{title}</PageTitle>
        </Col>
      </Row>
      <PageFilterInputs>{inputs}</PageFilterInputs>
    </PageFilterWrapper>
  );
};
export default PageFilter;
const PageFilterWrapper = styled.div<Pick<Props, "margin">>`
  height: 48px;

  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  margin: ${({ margin }) => margin || "0px 0px 0px 0px"};
`;
const SmallPageTitle = styled.div`
  ${theme.typo.body.r16};
`;
